import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBodyTooth = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.7083 12.9683C19.8984 11.4261 20.6084 9.56785 20.75 7.62501C20.741 6.61407 20.4285 5.62917 19.8528 4.79808C19.2772 3.96699 18.4651 3.32809 17.5218 2.96427C16.5786 2.60045 15.5478 2.52851 14.5631 2.75777C13.5785 2.98704 12.6855 3.50694 12 4.25001C11.3145 3.50694 10.4215 2.98704 9.43686 2.75777C8.45223 2.52851 7.42142 2.60045 6.47818 2.96427C5.53494 3.32809 4.72282 3.96699 4.14718 4.79808C3.57154 5.62917 3.25896 6.61407 3.25 7.62501C3.39158 9.56785 4.10161 11.4261 5.29167 12.9683C5.42669 13.1404 5.51204 13.3461 5.53849 13.5632C5.56493 13.7804 5.53144 14.0006 5.44167 14.2C5.04583 15.0908 3.70083 21.375 6.275 21.375C8.73333 21.375 6.49 16.375 11.6592 16.375H12.3333C17.5183 16.375 15.2442 21.375 17.7175 21.375C20.2942 21.375 18.9525 15.0942 18.555 14.2C18.4657 14.0003 18.4328 13.7799 18.4598 13.5628C18.4868 13.3457 18.5728 13.1401 18.7083 12.9683Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBodyTooth.displayName = 'SvgBodyTooth';
export default SvgBodyTooth;
